export const STATUS_LOGISTICS = {
  0: {
    label: 'Liberado',
    style: 'success-dark'
  },
  1: {
    label: 'Pendente',
    style: 'error-dark'
  },
  2: {
    label: 'Removido',
    style: 'warning-light'
  },
  3: {
    label: 'Agrupado',
    style: 'success-dark'
  },
  4: {
    label: 'Enviando',
    style: 'warning-light'
  },
  5: {
    label: 'Enviado',
    style: 'warning-light'
  },
  6: {
    label: 'Recusado',
    style: 'error-dark'
  },
  7: {
    label: 'Coletado',
    style: 'warning-light'
  },
  8: {
    label: 'Entregue',
    style: 'warning-light'
  },
  9: {
    label: 'Erro',
    style: 'warning-light'
  }
}
